import {
  createTheme,
  responsiveFontSizes,
  lighten,
  darken,
} from '@mui/material/styles';
import LinkBehavior from './utils/LinkBehavior';

const themeOptions = {
  // https://mui.com/customization/default-theme/?expand-path=$.palette.primary
  typography: {
    allVariants: {
      fontFamily: [
        'var(--font-poppins)',
        '"Helvetica"',
        'Arial',
        'sans-serif',
      ].join(', '),
      color: '#4f5858',
    },
    body2: {
      fontWeight: 500,
      color: '#626a6a',
    },
    button: {
      textTransform: 'none',
      fontSize: '1rem',
    },
    text: {
      primary: '#4f5858',
      secondary: '#757779',
      disabled: 'rgba(0, 0, 0, 0.38)',
    },
  },
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      },
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: LinkBehavior,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          // fontWeight: 500,
          // color: '#4f5858',
          textTransform: 'none',
          // '&:hover': {
          //   backgroundColor: '#f5f5f5',
          // },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
      defaultProps: {
        elevation: 2,
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          fontFamily: 'var(--font-poppins)',
          fontSize: '1.1rem',
          backgroundColor: 'transparent',
          border: '1px solid #f2f2f2',
        },
        colorDefault: {
          color: '#fff',
          backgroundColor: '#049aad',
          border: 'none',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontFamily: 'var(--font-poppins)',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '16px 24px',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#33CCCC',
      lightbg: lighten('#33CCCC', 0.8),
      contrastText: '#fff',
    },
    secondary: {
      main: '#ECA400',
      light: lighten('#ECA400', 0.3),
      contrastText: '#fff',
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      light: 'rgba(0, 0, 0, 0.6',
      notify: '#f30000',
      white: '#ffffff',
      disabled: 'rgba(0, 0, 0, 0.38)',
      grey: '#757E81',
    },
    background: {
      body: '#fafafa',
      image: '#494949',
      white: '#fff',
      gray: '#ced4da',
      innerGray: '#f2f2f2',
      buttonHover: '#f5f5f5',
    },
    gray: {
      main: '#f2f2f2',
      disabled: 'rgba(0, 0, 0, 0.3)',
      dark: darken('#f2f2f2', 0.1),
      border: '#ced4da',
    },
  },
};

// A custom theme for this app
// const theme = createTheme(themeOptions);
const theme = responsiveFontSizes(createTheme(themeOptions));
export default theme;
